import { useOnboardingStore } from "../../features/webAppOnboarding/store/onboardingStore";

export const useConfirmation = () => {
  const setConfirmationData = useOnboardingStore(
    (state) => state.setConfirmationModalData,
  );
  return setConfirmationData;
};
